interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  align?: "left" | "center";
  inverse?: boolean;
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = "center",
  inverse = false
}: SectionHeadingProps) {
  const alignment = align === "center" ? "mx-auto text-center" : "text-left";
  const titleColor = inverse ? "text-white" : "text-[#0C4A6E]";
  const descriptionColor = inverse ? "text-cyan-100" : "text-[#475569]";
  return <div className={`max-w-3xl ${alignment}`} data-id="element-141" data-mp="1763oq3relpu8">
      {eyebrow ? <p className={`mb-3 text-xs font-extrabold uppercase tracking-[0.2em] ${inverse ? "text-[#67E8F9]" : "text-[#0284C7]"}`} style={{
      fontSize: "14px"
    }} data-id="element-142" data-mp="178ggf8myrekh">
          {eyebrow}
        </p> : null}
      <h2 className={`font-heading text-3xl font-black tracking-tight sm:text-4xl lg:text-5xl ${titleColor}`} style={{
      fontSize: "28px"
    }} data-id="element-143" data-mp="ybxrs8lrmctp">{title}</h2>
      {description ? <p className={`mt-5 text-base leading-7 sm:text-lg ${descriptionColor}`} style={{
      fontSize: "15px"
    }} data-id="element-144" data-mp="oeja65o3vhzt">{description}</p> : null}
    </div>;
}